import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

const QRCodeComponent = ({ props }) => {
  const { t } = useTranslation();
  const replicaLink = props?.replicaLink;
      return (
    <div className="col-md-6">
      <div className="joinings_viewBox rounded shadow-sm p-4 bg-white">
        <div>
          <h5 className="mb-4">{t("replica")}</h5>
          <div className="col-12 text-center">
            {replicaLink ? (
              <QRCode value={replicaLink?.[0]?.link} />
            ) : (
              <p className="text-center">{t("noDataAvailable")}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeComponent;
